import { useLocation } from 'react-router-dom';

export function useQueryParam(param: string) {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    return queryParams.get(param);
}
